import "./Shop.module.css";
import Header from "@/reusable_sections/Header";
import Shop from "./sections/Shop";
import ShopContent from "./sections/ShopContent";
import Footer from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <Header />
      <Shop />
      <ShopContent />
      <Footer />
    </div>;
}